import { useQuery } from "@tanstack/react-query"

import type { RewavePoolResponse } from "@/components/sheriff/rewaving/types"
import { supabase } from "@/lib/supabase"
import { getFunctionsBaseUrl } from "@/utils/getFunctionsBaseUrl"

async function fetchRewavePool(depotId: string, date: string | null): Promise<RewavePoolResponse> {
  const { data: sessionData } = await supabase.auth.getSession()
  const token = sessionData.session?.access_token

  const params = new URLSearchParams({ depot_id: depotId })
  if (date) {
    params.set("date", date)
  }

  const res = await fetch(`${getFunctionsBaseUrl()}/shifts/rewaves?${params}`, {
    method: "GET",
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      "Content-Type": "application/json",
    },
  })

  const json = await res.json()
  if (!res.ok || json?.success === false) {
    throw new Error(json?.error || `Failed to fetch rewave pool (status ${res.status})`)
  }

  return json.data
}

export const useRewavePool = (depotId: string, date: string | null) => {
  return useQuery({
    queryKey: ["rewavePool", depotId, date],
    queryFn: () => fetchRewavePool(depotId, date),
    enabled: !!depotId,
  })
}
